export function getMicrosoftOAuthRedirectUri() {
    const strict =
      String(process.env.REACT_APP_MICROSOFT_REDIRECT_URI_STRICT || "")
        .toLowerCase() === "true";
    const explicit = (process.env.REACT_APP_MICROSOFT_REDIRECT_URI || "").trim();
    const apiHost = (process.env.REACT_APP_HTTPS_HOST || "").trim();
    const apiFallback = apiHost ? apiHost.replace(/\/?$/, "/") : "";
  
    if (typeof window === "undefined") {
      const uri = explicit || apiFallback;
      if (strict && !uri) {
        throw new Error(
          "Microsoft OAuth redirect URI is unset: set REACT_APP_MICROSOFT_REDIRECT_URI or REACT_APP_HTTPS_HOST when REACT_APP_MICROSOFT_REDIRECT_URI_STRICT is true.",
        );
      }
      return uri;
    }
  
    const host = window.location.hostname;
    const isLocal =
      host === "localhost" ||
      host === "127.0.0.1" ||
      host === "[::1]";
  
    if (strict) {
      return explicit || apiFallback || `${window.location.origin}/`;
    }
  
    if (isLocal) {
      return `${window.location.origin}/`;
    }
  
    if (explicit) {
      try {
        const explicitOrigin = new URL(explicit).origin;
        if (window.location.origin !== explicitOrigin) {
          return `${window.location.origin}/`;
        }
        return explicit;
      } catch {
        return `${window.location.origin}/`;
      }
    }
  
    return apiFallback || `${window.location.origin}/`;
  }